import { useState, useEffect } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const REVENUE_AGENCY_PAGE_SORT_FIELDS = ['id', 'name', 'isSystem', 'isActive', 'isHold', 'fakeType'] as const

export type IRevenueAgencySortField = typeof REVENUE_AGENCY_PAGE_SORT_FIELDS[number]

type IUseSortRevenueAgencyPage = {
	sortBy: IRevenueAgencySortField;
	setSortBy: (value: (((prevState: IRevenueAgencySortField) => IRevenueAgencySortField) | IRevenueAgencySortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IRevenueAgencySortField = 'id'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useRevenueAgencySortPage = (): IUseSortRevenueAgencyPage => {
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return REVENUE_AGENCY_PAGE_SORT_FIELDS.includes(item[0] as IRevenueAgencySortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IRevenueAgencySortField>(urlSort?.[0]?.[0] as IRevenueAgencySortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)
	const [send, setSend] = useState<boolean>(false)
	//console.log('useRevenueAgencySortPage:: ', { sortUrl: urlSort })

	useEffect(() => {
		if (sortBy && order) {
			setSend(true)

			const newSortStr = lib.sortSetup([[sortBy, order]])

			setSearchParams((prev) => {
				if (order !== ESortOrder.unset) {
					prev.set('s', newSortStr)
				} else {
					prev.delete('s')
				}

				return prev
			})
		}
	}, [sortBy, order])

	return {
		// sort: order !== ESortOrder.unset ? [[sortBy, order]] : [],
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}